import type { Citation } from './types';

export type Source = { url: string; host: string; title?: string | null };

const safeHost = (url: string): string | null => {
  try {
    const parsed = new URL(url);
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return null;
    return parsed.hostname;
  } catch {
    return null;
  }
};

/** One source per hostname (first URL wins), unsafe URLs dropped. */
export const dedupeSources = (citations: Citation[]): Source[] => {
  const byHost = new Map<string, Source>();
  for (const citation of citations) {
    const host = safeHost(citation.url);
    if (!host || byHost.has(host)) continue;
    byHost.set(host, { url: citation.url, host, title: citation.title });
  }
  return [...byHost.values()];
};
